module.exports = __webpack_public_path__ + "img/5367673357085_stp.prt.0722b55a.jpg";